/** Angular Imports */
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';


/** Custom Services */
import { AuthenticationService } from '../core/authentication/authentication.service';
import { HomeService } from './home.service';
import { TellerGlobalServiceService } from 'app/shared/teller-data/teller-global-service.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Teller } from 'app/model/teller';

/**
 * Home component.
 */
@Component({
  selector: 'mifosx-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  /** Username of authenticated user. */
  username: string;
  staffName: string;
  tellerList: Array<Teller>;
  selectedTeller: Teller;
  tellerStarted: boolean;
  tellerSelected: boolean = false;
  tellerSub: Subscription;
  tellerSelectorForm: FormGroup;

  /**
   * @param {AuthenticationService} authenticationService Authentication Service.
   * @param {FormBuilder} formBuilder Form Builder.
   */
  constructor(private authenticationService: AuthenticationService,
    private activatedRoute: ActivatedRoute,
    private homeService: HomeService,
    private tellerGlobalService: TellerGlobalServiceService,
    private formBuilder: FormBuilder) { }

  /**
   * Sets the username of the authenticated user.
   * Set Form.
   */
   ngOnInit() {
    const credentials = this.authenticationService.getCredentials();
    this.username = credentials.username;
    this.staffName = credentials.staffDisplayName;
    this.tellerStarted = false;

    this.activatedRoute.data.subscribe(({tellerList}) => {
      this.tellerList = tellerList;
    });

    this.tellerSub = this.tellerGlobalService.getSelectedTeller$().subscribe(data => this.selectedTeller = data);

    this.tellerSelectorForm  = this.formBuilder.group({
      "tellerSelectorForm": [null,Validators.required]
    });

    if(this.selectedTeller !== null && this.selectedTeller['id']){

      this.checkAndInvalidateSelectedTeller();
      this.tellerSelectorForm.get('tellerSelectorForm').setValue(this.selectedTeller);
      this.tellerStarted = this.selectedTeller['tellerStarted'];
      this.tellerSelected = true;
    }

  }

  ngOnDestroy(){

    if(this.tellerSub){
      this.tellerSub.unsubscribe();
    }

  }

  checkAndInvalidateSelectedTeller() {
    this.selectedTeller = this.tellerList.find(t => t.id === this.selectedTeller.id);
  }

  onTellerSelected(value: any){

    this.tellerGlobalService.setSelectedTeller(value);
    this.tellerStarted = this.selectedTeller['tellerStarted']
    this.tellerSelected = true;
  }
  
  onTellerstart(){
    this.homeService.tellerAction(this.selectedTeller['id'],'start')
    .subscribe(response => this.tellerStarted = true);
  }

  onTellerClosed(){
    this.homeService.tellerAction(this.selectedTeller['id'],'close')
    .subscribe(res => {
        this.closeTeller();

    });
  }

  setUpdateItemToClosed() {
    let updatedItem = this.tellerList.find(t => t.id === this.selectedTeller.id);
    let index = this.tellerList.indexOf(updatedItem);
    this.tellerList[index].tellerStarted = false;

  }

  closeTeller() {
    
    this.setUpdateItemToClosed();
    this.tellerGlobalService.setSelectedTeller({});
    this.tellerStarted = false;
    this.selectedTeller = null;
    this.tellerSelected = false;
    this.tellerSelectorForm.get('tellerSelectorForm').setValue(this.selectedTeller);
  }

  compareCategoryObjects(object1: any, object2: any) {
    return object1 && object2 && object1.id == object2.id;
  }


}
